import { RecordLockType } from 'types';
import { baseQuery } from '../baseQuery';
import { QueryFunctionContext } from 'react-query';

type CheckLockParams = {
  recordLockType: RecordLockType;
  recordId?: number;
};

export const getCheckLock = async ({ queryKey }: QueryFunctionContext<[string, CheckLockParams]>) => {
  const { recordLockType, recordId } = queryKey[1];
  const { data } = await baseQuery(`check-lock?record_lock_type=${recordLockType}&record_id=${recordId}`);

  return data;
};
